module.exports = "/cyber/_next/static/images/vesenniiBannerItogiTablet-4c528663286f3080e3781cbfcb3445c6.jpg";